<select [(ngModel)]="filter.value" class="form-control min-width" (ngModelChange)="onChange()" aria-label="Select filter">
  <option *ngIf="noValueOption" value="">{{ filter.getSelectionFilterTemplate().label | translate }}</option>
  <option *ngFor="let option of filter.getSelectionFilterTemplate().options" [ngValue]="option.value">{{ option.label | translate }}</option>
</select>
